import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resumeTournamentRest } from '@/services/tournaments/tournaments-service';

const useResumeTournament = (
  tournamentId: string,
  tournamentUrl: string,
  { onSuccess }: { onSuccess?: () => void } = {},
) => {
  const queryClient = useQueryClient();

  const { mutateAsync: resumeTournament } = useMutation({
    mutationFn: () => resumeTournamentRest(tournamentUrl),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tournament', tournamentId] });
      onSuccess?.();
    },
  });

  return { resumeTournament };
};

export default useResumeTournament;
